var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBellOutline = props => {
  const {
    size,
    color,
    svgProps
  } = props;
  props = {
    width: size || 24,
    height: size || 24,
    color: color || 'currentColor',
    ...svgProps
  };
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.333 17.5h3.334c0 .917-.75 1.667-1.667 1.667s-1.667-.75-1.667-1.667zm9.167-1.667v.834h-15v-.834l1.667-1.666v-5a5.8 5.8 0 014.166-5.584v-.25c0-.916.75-1.666 1.667-1.666s1.667.75 1.667 1.666v.25a5.8 5.8 0 014.166 5.584v5l1.667 1.666zm-3.333-6.666A4.126 4.126 0 0010 5a4.126 4.126 0 00-4.167 4.167V15h8.334V9.167z"
  })));
};
export default SvgBellOutline;